import { CssBaseline } from "@mui/material";
import { useRoutes } from "react-router-dom";
// Imported directly rather than via the "./components" barrel: that barrel
// also re-exports EchartTheme, which does `import * as echarts from 'echarts'`
// at module scope. Since App.jsx is always eager, going through the barrel
// pulled all of echarts (~450 modules) + zrender into the main bundle on
// every route, even though every chart-using view is already lazy-loaded.
import MatxTheme from "./components/MatxTheme/MatxTheme";
import { AuthProvider } from "./contexts/JWTAuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import routes from "./routes";
import { EmpListProvider } from "./contexts/EmployeeListContext";
import { TawkToProvider } from "./contexts/TawkToContext"; 
import './global.css';
// import "../fake-db";
const App = () => {
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <AuthProvider>
        <EmpListProvider>
          <MatxTheme>
            <CssBaseline />
            <TawkToProvider tawkToId="65d480269131ed19d96eee9f"> 
              {content}
            </TawkToProvider>
          </MatxTheme>
        </EmpListProvider>
      </AuthProvider>
    </SettingsProvider>
  );
};

export default App;
